import Sales from '../../../services/sales'
import {
  phone
} from '../../../filters/string'
import * as Utils from '../../../utils'
import C from '../constantes'
import toll from '../../../services/toll'

export default {
  props: ['request', 'minValue'],
  data() {
    return {
      rechargeValueTotal: 0,
      rechargeTaxTotal: 0,
      total: 0,
      cupom: undefined,
      totalComDesconto: 0,
      descontoCupom: 0,
      erroCupom: 0,
      loading: undefined,
      entries: undefined,
      showEntries: false,
    }
  },

  computed: {
    vehicles() {
      return this.request.listVehicle.vehicle
    },
    account() {
      return this.request.account;
    },
    address() {
      return this.request.addresses.address[0]
    },
    typeTel1() {
      let t = this.request.account.telephones.telephone[0];
      if (t)
        return t.type;
      return "";
    },
    typeTel2() {
      let t = this.request.account.telephones.telephone[1];
      if (t)
        return t.type;
      return "";
    },
    typeTel3() {
      let t = this.request.account.telephones.telephone[2];
      if (t)
        return t.type;
      return "";
    },
    tel1() {
      let t = this.request.account.telephones.telephone[0];
      if (t)
        return phone(t.ddd + t.numberPhone);
      return "";
    },
    tel2() {
      let t = this.request.account.telephones.telephone[1];
      if (t)
        return phone(t.ddd + t.numberPhone);
      return "";
    },
    tel3() {
      let t = this.request.account.telephones.telephone[2];
      if (t)
        return phone(t.ddd + t.numberPhone);
      return "";
    },
    isPF() {
      return this.request.account.type == 'PESSOA_FISICA';
    },
    payment() {
      return this.request.contract.paymentMethods.paymentMethod[0]
    },
    image() {
      if (this.payment.bankBill)
        return '/static/payment-methods/' + this.payment.bankBill.imagePath.split('.')[0] + '.svg';
      else if (this.payment.creditCard)
        return '/static/payment-methods/' + this.payment.creditCard.imagePath.split('.')[0] + '.svg';
      else if (this.payment.bankAccount)
        return '/static/payment-methods/' + this.payment.bankAccount.imagePath.split('.')[0] + '.svg';
    },
    isCaminhoParana() {
      return Utils.isCaminhoParana(this.request.contract.plan.planId);
    },
    planId() {
      return this.request.contract.plan.planId;
    },
    taxIdType() {
      return this.request.account.type == 'PESSOA_FISICA' ? 'CPF' : 'CNPJ';
    },
    plan() {
      return this.$store.getters.getPlanById(this.planId);
    },
    newAdhesionTax() {
      return this.$store.getters.getNewAdhesionTax(this.planId);
    },
    newVehicleTax() {

      // PLANOS QUE PERMITI ADESÂO ADICIONAL COM VALOR ZERO
      if ([52, 51].includes(this.planId))
        return 0;


      return this.newAdhesionTax;
      // return this.$store.getters.getNewVehicleTax(this.planId);
    },
    guaranteeTax() {
      return this.$store.getters.getGuaranteeTax(this.planId);
    },
    linkRntrcTax() {
      return this.$store.getters.getLinkRntrcTax(this.planId);
    },
    monthlyTax() {
      return this.$store.getters.getMonthlyTax(this.planId);
    },


  },

  mounted() {
    let vm = this;
    if (this.planHasRecharge(this.planId)) {
      let recRecharge = {
        planId: this.planId,
        value: this.request.contract.rechargeValue
      };

      let promise = Sales.calculateRechargeRate(recRecharge).then(r => {
        this.rechargeValueTotal = r.valueTotal;
        this.rechargeTaxTotal = r.taxTotal;
        this.calculateTotal();



        //GARANTE QUE OS DADOS DO DESCONTOS E TAXAS POSSAM SER CALCULADOS
        if (this.request.promotionCode && this.request.promotionCode != 'CAMINHOSDOPARANA') {
          this.cupom = this.request.promotionCode;

          this.calculateDiscount();

        }



      });

      this.$store.dispatch('loading', promise);
    } else {
      this.rechargeValueTotal = this.rechargeTaxTotal = 0;
      this.calculateTotal();
    }
    $('[data-toggle="tooltip"]').tooltip();


  },

  methods: {
    calculateTotal() {
      this.total = this.rechargeValueTotal + this.rechargeTaxTotal + this.newAdhesionTax + (this.guaranteeTax * this.vehicles.length);
      this.total += (this.vehicles.length - 1) * this.newVehicleTax;

      if (this.monthlyTax) {
        this.total += this.vehicles.length * this.monthlyTax;
      }

      if (this.planId == 2 || this.planId == 3) {
        this.total += this.vehicles.length * this.linkRntrcTax;
      }

      this.totalComDesconto = this.total;
      //desconto
      if (this.isCaminhoParana) {
        this.totalComDesconto = this.total - (this.vehicles.length * this.newVehicleTax);
      } else if (this.descontoCupom) {
        this.totalComDesconto = this.total - this.descontoCupom;
      }

      this.request.value = this.total;
    },
    adhesion() {
      Sales.adhesion(this.request);
    },
    validateAll() {
      return this.$validator.validateAll();
    },
    calculateDiscount() {


      this.erroCupom = '';
      let resolveTemp = undefined;

      let promotionCode = this.cupom;
      let planId = this.request.contract.plan.planId;
      let request = {
        promotionCode,
        planId
      };
      request.salesType = 'ADHESION';

      let discountRecharge = undefined;
      let discountAdhesion = undefined;
      let countDiscount = 0;




      let promise = Sales.calculateDiscount(request).then(response => {
        discountAdhesion = response;
        //PARA TRATAR PLANO ECONOMICO 51 e 52
        if (discountAdhesion && [51, 52].includes(this.planId)) {
          this.descontoCupom = this.rechargeTaxTotal;
        } else if (discountAdhesion) {
          if (discountAdhesion.productId == C.SALES_TYPE.ADHESION || discountAdhesion.productId == C.SALES_TYPE.GUARANTEE) {
            let qtd = discountAdhesion.discountLimit == 0 ? this.vehicles.length : Math.min(this.vehicles.length, discountAdhesion.discountLimit);
            this.descontoCupom = qtd * discountAdhesion.valueUnitDiscount;
          } else {
            this.descontoCupom = discountAdhesion.valueUnitDiscount;
          }
        }
        this.setPromotion(this.cupom);
        this.calculateTotal();
      }).catch(() => {
        this.erroCupom = 'Desconto não existe.';
        this.setPromotion(undefined);
      });

      this.$store.dispatch('loading', promise);

    },

    removeDiscount() {
      this.descontoCupom = 0;
      this.setPromotion(undefined);
      this.calculateTotal();
      this.cupom = '';
      this.erroCupom = '';
    },
    setPromotion(code) {

      if (this.request["promotionCode"] != 'CAMINHOSDOPARANA') {
        this.request["promotionCode"] = code;
        if (!code) {
          delete this.request["promotionCode"];
        }
      }
    },
    getTolls(state, associateId){
      this.loading = toll.getTollsByState(state)
        .then(res => {
            this.entries = _.filter(res, (o) => {
              return o.associateId == associateId;
            });
            this.showEntries = true;
        })
        .catch(err => {

        });

    },


  }
}



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/summary.js